module.exports = __webpack_public_path__ + "fonts/NeuePlak-CompBold.9c7730f7.woff2";